import {Component, Input} from '@angular/core';

@Component({
    selector: 'nz-logo',
    imports: [],
    templateUrl: './logo.component.html',
    styleUrl: './logo.component.scss'
})
export class LogoComponent {
  @Input() height: '50' | '70' | '100' | '150' = '70';
  @Input() mode: 'default' | 'monochromatic-light' = 'default';
}
